<template>
  <v-container>
    <StatsView :data="storageStats">
      <template #stats>
        <v-layout wrap class="mt-n4">
          <v-flex
            v-for="(item, i) in storageStats"
            :key="i"
            xs6
            sm4
            md3
            xl2
            class="lg5-custom"
          >
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card
                flat
                style="background-color: #ffffff"
                :elevation="hover ? 16 : 0"
                :class="{ 'on-hover': hover }"
                class="mx-2 mt-2"
              >
                <v-list>
                  <v-list-item class="stats">
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-lg-h5 stats-info font-weight-bold"
                        >{{ item.count }}</v-list-item-title
                      >
                      <v-list-item-subtitle class="stats-info">{{
                        item.name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-avatar :color="item.avatarColor" size="53">
                        <v-icon x-large :color="item.iconColor">{{
                          item.icon
                        }}</v-icon>
                      </v-avatar>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </template>
    </StatsView>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mt-6">
          <PieChart :pieData="pieData" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="mt-6">
          <BarChart :barData="barData" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import StatsView from "@kinetics254/cassandra-dashboards/Stats/StatsView.vue";
import PieChart from "@kinetics254/cassandra-dashboards/Charts/PieChart.vue";
import BarChart from "@kinetics254/cassandra-dashboards/Charts/BarChart.vue";
import helpers from "@kinetics254/cassandra-base/utilities/helpers/helper.js";

export default {
  name: "ImprestDashboard",
  components: { StatsView, PieChart, BarChart },
  data: function () {
    return {
      months: [
        "Jan",
        "Feb",
        "March",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("imprest/setBreadCrumbs", to);
      v.$store.dispatch("imprest/getImprests");
    });
  },

  computed: {
    storageStats: function () {
      const Statistics = this.$store.getters["imprest/imprests"];
      return [
        {
          count: Statistics ? Statistics.length : [],
          name: "All Imprests",
          avatarColor: "teal accent-2",
          iconColor: "teal darken-4",
          icon: "all_inbox",
          background: "coral",
        },
        {
          count: Statistics
            ? Statistics.filter(
                (i) => i.imprestStatus === "Draft" && i.status === "Open"
              ).length
            : [],
          name: "Draft",
          avatarColor: "orange accent-1",
          iconColor: "orange darken-4",
          icon: "open_in_new",
        },
        {
          count: Statistics
            ? Statistics.filter(
                (i) => i.imprestStatus === "Pending" && i.status === "Open"
              ).length
            : [],
          name: "Pending",
          avatarColor: "light-blue lighten-4",
          iconColor: "light-blue darken-4",
          icon: "pending",
        },
        {
          count: Statistics
            ? Statistics.filter(
                (i) => i.imprestStatus === "Approved" && i.status === "Open"
              ).length
            : [],
          name: "Under Review",
          avatarColor: "green accent-2",
          iconColor: "green darken-4",
          icon: "hourglass_top",
        },
        {
          count: Statistics
            ? Statistics.filter(
                (i) => i.imprestStatus === "Approved" && i.status === "Released"
              ).length
            : [],
          name: "Approved",
          avatarColor: "light-green lighten-4",
          iconColor: "light-green darken-4",
          icon: "check_circle",
        },
      ];
    },
    Stats() {
      return this.$store.getters["imprest/imprests"];
    },
    pieData() {
      return {
        labels: ["under Review", "Approved", "Draft", "Pending"],
        data: [this.underReview, this.Approved, this.Draft, this.Pending],
        title: "Imprest Status",
        backgroundColor: ["under Review", "Approved", "Draft", "Pending"].map(
          (el) => helpers.stringToColour(el)
        ),
      };
    },
    barData() {
      return {
        labels: this.months,
        data: this.months.map((el, index) => {
          return this.Stats.filter(
            (item) => new Date(item.postingDate).getMonth() === index
          ).length;
        }),
        title: "Imprest Timeline",
        backgroundColor: this.months.map((el) => helpers.stringToColour(el)),
        amount: this.months.map((el, index) => {
          return this.Stats.filter(
            (item) => new Date(item.postingDate).getMonth() === index
          ).reduce(function (a, b) {
            return parseInt(a) + parseInt(b.amountToPayHeader);
          }, 0);
        }),
      };
    },
    underReview() {
      const Statistics = this.$store.getters["imprest/imprests"];
      return Statistics
        ? Statistics.filter(
            (i) => i.imprestStatus === "Approved" && i.status === "Open"
          ).length
        : [];
    },
    Approved() {
      const Statistics = this.$store.getters["imprest/imprests"];
      return Statistics
        ? Statistics.filter(
            (i) => i.imprestStatus === "Approved" && i.status === "Released"
          ).length
        : [];
    },
    Draft() {
      const Statistics = this.$store.getters["imprest/imprests"];
      return Statistics
        ? Statistics.filter(
            (i) => i.imprestStatus === "Draft" && i.status === "Open"
          ).length
        : [];
    },
    Pending() {
      const Statistics = this.$store.getters["imprest/imprests"];
      return Statistics
        ? Statistics.filter(
            (i) => i.imprestStatus === "Pending" && i.status === "Open"
          ).length
        : [];
    },
  },

  methods: {},
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@media (min-width: 960px) {
  .flex.md3.lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
.kyler {
  stroke: white;
  stroke-width: 5px;
}
</style>
